<template>
  <div>
    <div v-if="!hasCollectAll">
      <div class="pop-msg">恭喜您额外获得一张 <span>{{ cardsValue }}积分抵用券</span></div>
      <div class="pop-detail">
        点击详情了解使用
        <img src="../../../assets/images/activity/collect-cards-view.png" @click.stop="handleViewDetail">
      </div>
    </div>

    <div v-else>
      <div class="pop-msg-all">恭喜您集齐“春暖花开”</div>
      <div class="pop-detail pop-detail-all">
        免费领取大礼包
        <img src="../../../assets/images/activity/collect-cards-view.png" @click.stop="handleViewDetail">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CollectCardsPopup',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      springActivityData: state => state.lottery.springActivityData,
      cardsValue: state => state.lottery.cardsValue,
      hasCollectAll: state => state.lottery.hasCollectAll
    })
  },
  methods: {
    handleViewDetail () {
      this.$router.push({ name: 'activity-collect-cards' })
    }
  }
}
</script>

<style lang="less" scoped>
.pop-msg {
  padding-top: 10px;
  span {
    font-size: 16px;
    font-weight: 600;
    color: #ed4836;
  }
}
.pop-detail {
  line-height: 40px;
  img {
    width: 80px;
    vertical-align: middle;
  }
}
.pop-msg-all {
  font-weight: 600;
  color: #ed4836;
}
.pop-detail-all {
  font-size: 16px;
  color: #ed4836;
}
</style>
